export const features =  {
    AdminEdits:true,
    AllCountries:false,
    WithWebsitePages:true,
    MobileLogin:true,
    FacebookLogin:false,
    AppleLogin:false
};